// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"bksw"};